import { makeStyles, createStyles, Theme } from '@material-ui/core';

import { monochrome } from '../../theme/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      width: 560,
      maxWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        width: 'auto',
      },
    },
    optionCard: {
      width: '100%',
      padding: 20,
      textAlign: 'left',
      textTransform: 'none',
      justifyContent: 'flex-start',
      borderRadius: 12,
      border: `1px solid ${theme.palette.type === 'dark' ? monochrome.dark : monochrome.mediumlight}`,
      // MUI wraps children in .MuiButton-label, so the gap must live there.
      '& .MuiButton-label': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 20,
      },
    },
    optionIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 48,
      height: 48,
      borderRadius: 12,
      flexShrink: 0,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.type === 'dark' ? monochrome.darker : monochrome.mediumlight,
    },
    noteBox: {
      padding: 12,
      borderRadius: 8,
      backgroundColor: theme.palette.type === 'dark' ? monochrome.darker : monochrome.mediumlight,
    },
    manualLink: {
      alignSelf: 'center',
      '& .MuiButton-label': {
        textDecoration: 'underline',
      },
    },
    thumbnailsWrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, 100px)',
      gridGap: 16,
    },
    thumbnail: {
      position: 'relative',
      width: 100,
      height: 100,
    },
    thumbnailImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 8,
      border: `1px solid ${theme.palette.type === 'dark' ? monochrome.dark : monochrome.mediumlight}`,
    },
    removeButton: {
      position: 'absolute',
      top: -10,
      right: -10,
      padding: 6,
      borderRadius: 10,
      border: `1px solid ${theme.palette.type === 'dark' ? monochrome.dark : monochrome.mediumlight}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.error.main,
    },
    overlay: {
      position: 'absolute',
      inset: 0,
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 40,
      gap: 8,
      backgroundColor: theme.palette.background.paper,
    },
    successIcon: {
      color: theme.palette.success.main,
    },
  })
);
